import { isBrowser } from 'embed/utils/browser/isBrowser'

export class NotInBrowserError extends Error {
  constructor() {
    super('This function expected to be ran in the browser, but window was not found.')
  }
}

export const AssertIsInBrowser = () => {
  if (!isBrowser()) {
    throw new NotInBrowserError()
  }
}
